var e4 = e4 || {},
        rybners = rybners || {};
( function () {
    'use strict';
    rybners.bootstrapInitialize = {
        init: function () {
            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            if ( viewportWidth > e4.settings.breakpoint.lg ) {
                //Only load tooltip on desktop
                jQuery( '[data-toggle="tooltip"]' ).tooltip( { html: true } );
                jQuery( '.p-accordion-item' ).removeAttr( 'title' );

                // Disable collapse on desktop
                jQuery( '.js-rybners-disable-collapse-on-desktop [data-toggle="collapse"]' ).click( function ( e ) {
                    e.preventDefault();
                    e.stopPropagation();
                } );
            }
        }
    };
    jQuery( function () {
        rybners.init();
    } );
    rybners.init = function () {
        rybners.dealersearch.init();
        rybners.courses.init();
        rybners.filePublisherLink.init();
        rybners.courseSignup.init();
    };


    rybners.courseSignup = {
        init: function () {
            rybners.courseSignup.bindEvents();
        },
        formPageUrl: null,
        formLoader: function ( strPageUrl ) {
            var jFeedbackForm = jQuery( '.js-rybners-course-signup-container' );
            rybners.courseSignup.formPageUrl = strPageUrl;
            jQuery.ajax({
                url: strPageUrl,
                success: function( data ) {
                    data = jQuery( data ).find( '.e-form-dw' );
                    jFeedbackForm.hide().html( data ).fadeIn('slow');
                    //jQuery( '.js-rybners-form-page-url' ).val( location.href );
                    rybners.courseSignup.formValidator( strPageUrl );
                }
            });
        },
        formValidator: function () {
            var jFeedbackForm = jQuery( '.js-rybners-course-signup-container' );

            jFeedbackForm.find( 'form' ).validate( {
                submitHandler: function ( form ) {
                    console.log( 'validated' )
                    if ( jQuery( form ).is( '.js-e-form-dw' ) === true ) {
                        //Read Dynamicweb spam script from inline script block inside the forms.
                        var fnDwFormSpamScript = e4.data.get( 'forms.dwSpamScripts.' + form.id );
                        if ( jQuery.isFunction( fnDwFormSpamScript ) === true ) {
                            fnDwFormSpamScript.call( window, form );
                        }
                        // console.log( e4.data.forms.dwSpamScripts );
                    }
                    rybners.courseSignup.feedbackSubmit( form );
                }
            } );
        },
        feedbackSubmit: function ( domElm ) {
            var jFeedbackForm = jQuery( '.js-rybners-course-signup-container' );
            var jFeedbackFormSuccessMsg = 'Test';
            var jFeedbackFormSuccessContainer = '<p class="' + "rybners-feedback-success-text" + '">' + '<span class="' + 'material-icons text-success">' + 'check_circle' + '</span>' + jFeedbackFormSuccessMsg + '</p>'
            console.log( 'rybners.courseSignup.formPageUrl', rybners.courseSignup.formPageUrl )

            var jqXHR = jQuery.ajax( {
                method: 'POST',
                url: rybners.courseSignup.formPageUrl,
                data: jQuery( domElm ).serialize()
            } );
            jqXHR.done( function ( data ) {
                if ( data ) {
                    //jFeedbackForm.modal( 'hide' );
                    jFeedbackForm.find( '.e-form-dw' ).hide();
                    jFeedbackForm.append( jFeedbackFormSuccessContainer ).hide().fadeIn( 'slow' );
                }
            } );
            jqXHR.fail( function ( error ) {
                console.error( error );
            } );
        },
        generateUrl: function ( str ) {
            var jFeedbackForm = jQuery( '.js-rybners-course-signup-container' );
            var strPageId = '';

            if ( str === '1' ) {
                strPageId = jFeedbackForm.data( 'idv1-formpageid' )
            }
            else if ( str === '2' ) {
                strPageId = jFeedbackForm.data( 'idv2-formpageid' )
            }
            else {
                strPageId = jFeedbackForm.data( 'idv3-formpageid' )
            }

            var strPageUrl = '/Default.aspx?Id=' + strPageId;

            return strPageUrl;
        },
        bindEvents: function () {
            jQuery( '.js-rybners-course-signup-selector' ).on( 'change', function ( event, data ) {
                var strSelectedUserType = jQuery( '.js-rybners-course-signup-input' ).val();
                var strPageUrl = rybners.courseSignup.generateUrl( strSelectedUserType );
                rybners.courseSignup.formLoader( strPageUrl );
            } );
        }
    };


    rybners.filePublisherLink = {
        init: function () {
            rybners.filePublisherLink.filePublisherItem();
        },
        filePublisherItem: function() {
            var jFilePublisherItem = jQuery( '.js-rybners-filepublisher-item' );
            rybners.filePublisherLink.replaceItemUrl( jFilePublisherItem )
        },
        replaceItemUrl: function ( items ) {
            items.each( function ( intIndex, domElm) {
                var strFilePublisherUrl = jQuery( domElm ).data( 'fileUrl' );
                jQuery( domElm ).find( 'a' ).prop( 'href', strFilePublisherUrl );
            });
        }
    }

    rybners.courses = {
        init: function () {
            rybners.courses.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-rybners-sign-up-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var strSelectedUserType = jQuery( '.js-rybners-sign-up-select-input' ).val();
                if ( strSelectedUserType === 'ledig' || strSelectedUserType === 'aktoer' ) {
                    jQuery( '.js-rybners-contact-modal' ).modal();
                }
                else {
                    if ( strSelectedUserType !== '' ) {
                        window.open( event.target.action );
                    }
                }
            } );
            jQuery( '.js-rybners-teams-select-input').on( 'change', function ( event ) {
                jQuery( '.js-rybners-sign-up-form' ).attr('action', event.target.value);
                var kvikNr = event.target.options[event.target.options.selectedIndex].dataset.kviknr;
                jQuery('.js-rybners-kviknr').text(kvikNr);
            } );



        }
    };
    rybners.dealersearch = {
        options: {
            url: '/system/data/dealersearch',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        notChangedYet: true,
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch-form' );
                    rybners.dealersearch.bindEvents();
                    rybners.dealersearch.get( true );
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-form-container' ).on( 'input', '.js-rybners-employee-search', e4.util.debounce( function () {
                rybners.dealersearch.get();
            }, 500 ) ).on( 'change', '.js-rybners-employee-selector', function () {
                rybners.dealersearch.get();
            } );
        },
        get: function ( boolDoFormUpdate ) {
            jQuery( '#js-e-dealersearch-container' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            jQuery.ajax( {
                url: rybners.dealersearch.options.url,
                type: 'GET',
                data: {
                    GroupID: jQuery( '.js-find-employee-group-name' ).val(),
                    q: jQuery( '.js-rybners-employee-search' ).val()

                },
                dataType: 'json'
            } )
                  .done( function ( data ) {
                      console.log( 'data', data );
                      rybners.dealersearch.build( data );
                      if ( boolDoFormUpdate === true ) {
                          rybners.dealersearch.buildForm( data );
                      }
                  } )
                  .fail( function ( error ) {
                      console.error( error );
                  } )
                  .always( function () {
                      jQuery( '#js-e-dealersearch-container' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                  } );
        },
        buildForm: function ( data ) {
            /*            var jContainer = jQuery( '#js-e-dealersearch-form-container' );
             jContainer.html( e4.handlebars.tmpl.dealersearchForm( data ) );*/
        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-container' );
            /*if ( data.q ) {
             data.dealers = rybners.dealersearch.sortDealersByRelevans( data.dealers, data.q );
             }*/

            jContainer.html( e4.handlebars.tmpl.dealersearch( data ) );
        },
        sortDealersByRelevans: function ( arrDealers, strQuery ) {
            var arrMatches = [],
                    arrNoMatches = [];
            for ( var i = 0; i < arrDealers.length; i++ ) {
                var strFirstname = arrDealers[ i ].firstname.value.toLowerCase();

                if ( strFirstname.indexOf( strQuery.toLowerCase() ) === 0 ) {
                    arrMatches.push( arrDealers[ i ] );
                }
                else {
                    arrNoMatches.push( arrDealers[ i ] );
                }
            }
            return ( arrMatches.concat( arrNoMatches ) );
        }
    };

}() );
